import React from 'react';
import HeaderBuyStep from "../HeaderBuyStep";
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const SuccessPage = () => {
    return (
        <div className="success-page-wrapper">
            <div className="success-page-content d-flex text-center align-items-center flex-column">
                <div className="ok-icon xmb-6"><IconName name="done_outline" className="icon"/></div>
                <div className="text-success-page xmb-10"><span className="text">خرید شما با موفقیت انجام شد.</span>
                </div>
                <div className="time-send persian-number xmb-2">و در روز 28 بهمن به دست شما خواهد رسید</div>
                <div className="code">کد پیگیری شما #xxxxxx</div>

                <div className="button-success xmb-4"><a href="#">مشاهده‌ی داشبورد</a></div>
                <div className="back-home-page"><Link to="/">شروع خرید بعدی</Link></div>
            </div>
        </div>
    );
};

export default SuccessPage;
